import * as React from "react";
import ContentLoader from "react-content-loader";

export const LoadingShimmer: React.FunctionComponent<{}> = () => (
    <ContentLoader height={380} width={240} speed={3} primaryColor="#f3f3f3" secondaryColor="#ecebeb">
        <rect x="9" y="15" rx="5" ry="5" width="220" height="264" />
        <rect x="11" y="295" rx="0" ry="0" width="219" height="19" />
        <rect x="149" y="304" rx="0" ry="0" width="0" height="0" />
        <rect x="149" y="304" rx="0" ry="0" width="0" height="0" />
        <rect x="11" y="322" rx="0" ry="0" width="220" height="13" />
        <rect x="156" y="333" rx="0" ry="0" width="0" height="0" />
        <rect x="10" y="343" rx="0" ry="0" width="220" height="13" />
    </ContentLoader>
);
